import template from './notification_management.edit.html';
import controller from './notification_management.edit.controller';
import './notification_management.edit.scss';

let NotificationManagementEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default NotificationManagementEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/edit/notification_management.edit.component.js